import {$get, $postForm} from "../../core/js/Ajax.ts";
import {
    $,
    $$,
    empty,
    getParentElementById,
    getParentElementByTagName
} from "../../core/js/Dom.ts";
import {initTooltips} from "../../core/js/Tooltip.ts";
import {fadeIn, fadeOut, fadeOutFadeIn} from "../../core/js/Animate.ts";
import {initDatefield} from "../../core/js/Date.ts";
import {createModale, showModal} from "../../core/js/Modal.ts";
import {SelecteurDeServices} from "../../core/js/SelecteurDeServices.ts";
import {refreshPage} from "../../core/js/Utils.ts";
import {stopPropagation} from "../../core/js/Event.ts";
import {gererInteractionOnglet} from "../../core/js/Onglets.ts";

document.addEventListener('DOMContentLoaded', () => {
    if (["reunionCDSR_list", "reunionCDSR_archives"].includes(document.body.dataset.url!)) {
        initListeners()
        initState()
    }
    if (["reunionCDSR_convocation_list"].includes(document.body.dataset.url!)) {
        $('#apporter_reponse_convocation_cdsr')?.addEventListener('click', envoiGroupeReponseConvocationCDSR)
        $('#selectionner_tous_oui_convocation_cdsr')?.addEventListener('click', selectionnerTousOui)
    }
})

function initState() {
    requestAnimationFrame(() => {
        $('.link_tab[tabindex="0"]')?.click()
    })
}

function initListeners() {
    gererInteractionOnglet(loadCDSR, '.link_tab')
    initDatefield('.btn-date-form')
    $('#select_annee')?.addEventListener('change', handleArchiveDateChanged)
}

async function loadCDSR(target: HTMLElement|null) {
    const cdsr_id = target?.dataset.pk
    const tab = $(`#${target?.getAttribute('aria-controls')}`)
    if (cdsr_id && tab) {
        const content = await loadCDSRContent(cdsr_id)
        setCDSRContent(tab, content)
        initTooltips(tab)
        initCDSRListeMembres(tab)
    }
}

function loadCDSRContent(cdsr_id: string): Promise<string> {
    return new Promise((resolve) => {
        let url = `/structure/CDSR/${cdsr_id}/`
        $get(url).then((response) => {
            resolve(response.body)
        })
    })
}

function setCDSRContent(tab: HTMLElement, content: string) {
    tab.innerHTML = content
}


export function initCDSRListeMembres(container: Document | HTMLElement | string | null = document) {
    if (container === null) return
    let parent: HTMLElement | Document | null
    if (typeof container === 'string') parent = $<HTMLElement>(container)
    else parent = container

    if (parent) {
        stopPropagation($$('.ouvrir_dossier', parent), 'click')
        stopPropagation($$('.btn-date-form', parent), 'click')
        $$('.btn-modal-presentation-cdsr', parent).forEach(el => el.addEventListener('click', showCDSRInvitationModal))
        $$('.btn-date-form', parent).forEach(el => initDatefield('.btn-date-form', el.parentElement))
        $$('.cdsr_del', parent).forEach(el => el.addEventListener('click', handleUpdateCdsrMembres))
        $$('#reunion', parent).forEach(el => el.addEventListener('change', handleCdsrChange))
        const actionCdsr = $$('.annulation_cdsr', parent)
        const confirmActionCdsr = $$('.confirmer_annulation_cdsr', parent)
        actionCdsr.forEach((el, index) => el.addEventListener('click', () => {
            fadeOutFadeIn(el, confirmActionCdsr[index])
        }))

        const actionDateCdsr = $$('#cdsr_supprimer_reunion', parent)
        const confirmActionDateCdsr = $$('#confirmer_cdsr_supprimer_reunion', parent)
        actionDateCdsr.forEach((el, index) => el.addEventListener('click', () => {
            fadeOutFadeIn(el, confirmActionDateCdsr[index])
        }))

        $$('.action-show-only-cdsr', parent).forEach(el => el.addEventListener('click', handleToggleShowCdsr))

        $$('.btn_doc', parent).forEach(el => el.addEventListener('click', ShowAjoutPieceJointeCdsr))

        $$('.cdsr_convocation_file_checkbox').forEach(el => el.addEventListener('change', handleCheckEnvoiParLot))

        $$('.a_cdsr_convocation').forEach(el => el.addEventListener('click', showConvocationForm))
        $$('.document_convocation_cdsr').forEach(el => el.addEventListener('change', handleFileInputChange))

        $$('.cdsr_convocation_envoye').forEach(el => el.addEventListener('submit', handleEnvoyerConvocationCDSR))
        $('#cdsr_convocation_form_lot')?.addEventListener('submit', handleEnvoyerConvocationCDSRParLot)
    }
}

function showCDSRInvitationModal(event: DOMEvent<HTMLElement>) {
    event.preventDefault()
    const target = getParentElementByTagName(event.target, 'button')
    const modale = createModale('demandeAvisModal', {
        title: window.Openscop.selecteur.cdsr_invitation.modal_title,
    })
    if (modale && target) {
        let selecteur: SelecteurDeServices
        showModal('demandeAvisModal', {
            disableScroll: true,
            onClose: () => {
                if (selecteur?.demandeEnvoyer) refreshPage()
            }
        })
        selecteur = new SelecteurDeServices({
            ...window.Openscop.selecteur.cdsr_invitation,
            ajout: "ajouter_invite",
        })
    }
}

function handleUpdateCdsrMembres(event: DOMEvent<HTMLElement>) {
    const target = getParentElementByTagName(event.target, 'button')
    if (target) {
        const url = target.dataset.url
        const membre_id = target.dataset.membre
        if (url && membre_id) {
            $get(url, {membre_id}).finally(() => {
                refreshPage()
            })
        }
    }
}

function handleCdsrChange(event: DOMEvent<HTMLSelectElement>) {
    const target = event.target
    let pk = target.value;
    let parametres = new URLSearchParams(window.location.search);
    const date_result = $('#select-date-result')
    fadeOut(date_result)
    empty(date_result)
    if (pk !== "") {
        parametres.set('reunion', pk)
        $get(window.Openscop.url_presentationcdsr_set_date, parametres).then(() => {
            refreshPage()
        }).catch((error: IAjaxError) => {
            const erreurElement = $('#select-date-result')
            erreurElement!.innerHTML = error.message;
            fadeIn(erreurElement)
        });
    }
}

function ShowAjoutPieceJointeCdsr(event: DOMEvent<HTMLElement>) {
    const target = getParentElementByTagName(event.target, 'button')
    const membre = target?.dataset.membre
    if (target && membre) {
        fadeOut(target)
        fadeIn($(`#form_ajout_doc${membre}`))
    }
}

function handleToggleShowCdsr(event: DOMEvent<HTMLElement>) {
    event.stopPropagation()
    event.preventDefault()
    const target = getParentElementById(event.target, 'panneau_gauche')
    if (target) {
        $$('section:not([data-cdsr])', target).forEach(el => {
            if (el.classList.contains('d-none')) {
                fadeIn(el)
            } else {
                fadeOut(el)
            }
        })
    }
}

function handleCheckEnvoiParLot() {
    const options = $$<HTMLInputElement>('.cdsr_convocation_file_checkbox')
    const activateLot = Array.from(options).some(el => el.checked)
    if (activateLot) {
        $('.a_cdsr_convocation[data-membre="lot"]')?.removeAttribute('disabled')
        $$('.a_cdsr_convocation.d-none').forEach((el) => {
            if (el.dataset.membre !== 'lot') fadeOutFadeIn($(`#cdsr_convocation_form_${el.dataset.membre}`), el)
        })
    } else {
        const buttonLot = $('.a_cdsr_convocation[data-membre="lot"]')
        buttonLot?.setAttribute('disabled', '')
        if (buttonLot?.classList.contains('d-none')) {
            fadeOutFadeIn($('#cdsr_convocation_form_lot'), buttonLot)
        }
    }
}

function envoiGroupeReponseConvocationCDSR(event: DOMEvent<HTMLFormElement>) {
    event.preventDefault()
    const form = getParentElementByTagName(event.target, 'form') as HTMLFormElement
    const url = form?.getAttribute('action')
    if (url && form) {
        const data = new FormData(form)
        $postForm(url, data).then((response) => {
            if (response.body === "") {
                refreshPage()
            } else {
                window.location.href = response.body
            }
        }).catch(erreur => {
            $('#erreur_cdsr_convocation')!.innerHTML = `<div class="fr-alert fr-alert--error" role="alert" >${erreur.message}</div>`
        })
    }
}

function selectionnerTousOui(event: DOMEvent<HTMLFormElement>) {
    event.preventDefault()
    // const checkBoxOui = getParentElementByClassName(event.target, 'reponse_oui_convocation_cdsr') as HTMLFormElement
    const checkBoxOui = document.querySelectorAll<HTMLInputElement>('input.reponse_oui_convocation_cdsr[type="radio"]');
    if (checkBoxOui) {
        checkBoxOui.forEach(el => {
            el.checked = true;
        });
    }
}

function handleEnvoyerConvocationCDSR(event: DOMEvent<HTMLFormElement>) {
    event.preventDefault()
    const myFormData = new FormData(event.target);
    envoyerConvocations(event.target.action, myFormData, event.target.dataset.membre)
}

function handleEnvoyerConvocationCDSRParLot(event: DOMEvent<HTMLFormElement>) {
    event.preventDefault()
    let id = "";
    $$<HTMLInputElement>(".cdsr_convocation_file_checkbox:checked").forEach((el) => {
        id += `_${el.value}`
    });
    const myFormData = new FormData(event.target);
    myFormData.append('membres', id);
    envoyerConvocations(event.target.action, myFormData, event.target.dataset.membre)
}

function envoyerConvocations(url: string, formData: FormData, membre: string) {
    $postForm(url, formData).then((response) => {
        if (response.response.status === 200) {
            window.location.reload()
        } else {
            const error = $(`#erreur_cdsr_convocation_${membre}`)
            if(error) {
                error.innerHTML = response.body
                fadeIn(error)
            }
        }
    }).catch(err => {
        const error = $(`#erreur_cdsr_convocation_${membre}`)
            if(error) {
                error.innerHTML = err.message
                fadeIn(error)
            }
    })
}

function showConvocationForm(event: DOMEvent<HTMLElement>) {
    const target = getParentElementByTagName(event.target, 'button')

    const pk = target?.dataset.membre
    if (pk) {
        fadeOutFadeIn(target, $(`#cdsr_convocation_form_${pk}`))
    }
    if (pk !== 'lot') {
        $$<HTMLInputElement>('.cdsr_convocation_file_checkbox').forEach(el => el.checked = false)
        const buttonLot = $('.a_cdsr_convocation[data-membre="lot"]')
        buttonLot?.setAttribute('disabled', '')
        if (buttonLot?.classList.contains('d-none')) {
            fadeOutFadeIn($('#cdsr_convocation_form_lot'), buttonLot)
        }
    }
}

function handleFileInputChange(event: DOMEvent<HTMLInputElement>) {
    const form = getParentElementByTagName(event.target, 'form')
    if(form) {
        const button = $('button', form)
        if (event.target.files?.length > 0) {
            button?.removeAttribute('disabled')
        } else {
            button?.setAttribute('disabled', '')
        }
    }
}

function handleArchiveDateChanged(event: DOMEvent<HTMLSelectElement>) {
    const select = event.target.slim
    const annee = select?.getSelected()[0]
    window.location.assign(window.location.pathname + '?annee=' + annee)
}

function sendConfirmationCdsr(event: DOMEvent<HTMLElement>) {
    event.preventDefault()
    const form = $$('.openscop-modal-form', $('#modal-cdsr-confirm-form-body')!)[0] as HTMLFormElement
    const url = form?.getAttribute('action')
    if (url && form) {
        const data = new FormData(form)
        $postForm(url, data).then((_response) => {
            refreshPage()
        }).catch(erreur => {
            $('#message-erreur-date')!.innerHTML = `<div class="fr-alert fr-alert--error" role="alert" >${erreur.message}</div>`
        })
    }
}

export function showModalConfirmationCdsr(event: DOMEvent<HTMLElement>) {
    event.preventDefault()
    const modal_body = $('#modal-cdsr-confirm-form')
    // const modale = createModale('cdsr-confirm-form-modal')
    const url_form = event.target?.getAttribute('data-url-form-pk')!;
    if ( modal_body) {
        showModal(modal_body.id, {})
        $get(url_form).then((response) => {
            $('#modal-cdsr-confirm-form-body')!.innerHTML = response.body
            fadeIn(modal_body)
            $('.openscop-modal-form')?.setAttribute('action', url_form)
            $('.openscop-modal-form')?.addEventListener('submit', sendConfirmationCdsr)
            $('#submit-form-modal')?.addEventListener('click', sendConfirmationCdsr)
        })
    }

}

